import { render, staticRenderFns } from "./menu-dragable.vue?vue&type=template&id=7df6d384&scoped=true&"
import script from "./menu-dragable.vue?vue&type=script&lang=js&"
export * from "./menu-dragable.vue?vue&type=script&lang=js&"
import style0 from "./menu-dragable.vue?vue&type=style&index=0&id=7df6d384&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df6d384",
  null
  
)

export default component.exports